import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import { css, styled, type Theme } from '@mui/material/styles';

const sharedArrowIconStyles = (theme: Theme) => css`
  font-size: ${theme.typography.pxToRem(14)};
  margin-left: ${theme.spacing(0.5)};
  position: absolute;
  top: 30%;
`;

export const StyledArrowUpward = styled(ArrowUpward)`
  ${({ theme }) => sharedArrowIconStyles(theme)}
`;

export const StyledArrowDownward = styled(ArrowDownward, { shouldForwardProp: prop => prop !== 'isDisabled' })<{
  isDisabled?: boolean;
}>`
  ${({ theme }) => sharedArrowIconStyles(theme)}
`;
